import { Allergen } from '../types';

const ICON_RULES: Array<{ pattern: RegExp; icon: string }> = [
  { pattern: /молок|milk|лактоз/i, icon: '🥛' },
  { pattern: /глютен|пшениц|жит|ячмін|oat|wheat|grain/i, icon: '🌾' },
  { pattern: /арахіс|горіх|peanut|nut|мигдал|фісташ/i, icon: '🥜' },
  { pattern: /яйц|egg/i, icon: '🥚' },
  { pattern: /риб|fish/i, icon: '🐟' },
  { pattern: /ракоподіб|молюск|кревет|seafood|shellfish|crustacean/i, icon: '🦐' },
  { pattern: /со[яє]|soy/i, icon: '🫘' },
  { pattern: /кунжут|sesame/i, icon: '⚪' },
  { pattern: /селера|celery/i, icon: '🌿' },
  { pattern: /гірчиц|mustard/i, icon: '🟡' },
  { pattern: /сульфіт|sulph|sulf/i, icon: '🧪' },
  { pattern: /люпин|lupin/i, icon: '🌼' },
];

export const getAllergenIcon = (name: string): string => {
  const normalized = name.trim();
  if (!normalized) return '⚠️';
  const matched = ICON_RULES.find((rule) => rule.pattern.test(normalized));
  return matched?.icon ?? '⚠️';
};

export const getAllergenBadges = (allergens: Allergen[]): string[] =>
  allergens.map((a) => `${getAllergenIcon(a.name)} ${a.name}`);
